import { Exclude } from "class-transformer";
import VueI18n from "vue-i18n";

import { PeriodConditionsTypeEnum } from "../types";

export abstract class BasePeriodCondition {

  @Exclude()
  i18n!: VueI18n

  abstract type: PeriodConditionsTypeEnum

  abstract getModel(): unknown;
  abstract getBeautifiedValues(...args: Array<any>): unknown;

  async validate() {
    return true
  }

  abstract removeValue(...args: Array<any>): void
  abstract addValue(...args: Array<any>): void
  abstract isEmpty(): boolean
}
